import{jsxs as k,Fragment as u,jsx as n}from"react/jsx-runtime";import{useRef as b,useEffect as O}from"react";import{createPortal as C}from"react-dom";import h from"styled-components";import{CSSTransition as y}from"react-transition-group";import E from"./Overlay.js";import{useOutsideClick as N}from"./useClickOutside.js";import{FocusTrap as P}from"../FocusTrap.js";const D="offCanvasAnimation",S={timeout:{enter:300,exit:300},mountOnEnter:!0,unmountOnExit:!0},T=h.div`
  ${({animationName:t,animationDuration:s,width:e,from:o,backgroundColor:l,theme:i})=>`
    position: fixed;
    z-index: 1001;
    width: 100%;
    height: 100%;
    top: 0;
    ${o==="left"?"left: 0;":"right: 0;"}
    background-color: ${l||i.colors.background.light};
    width: ${e};
    box-shadow: 0 0 0.5em rgba(0, 0, 0, 0.2);


    &.${t}--right-enter {
      transform: translate3d(${e}, 0, 0);
    }

    &.${t}--right-enter.${t}--right-enter-active {
      transform: translate3d(0, 0, 0);
      transition: transform 0.2s ease-in-out;
    }

    &.${t}--right-exit {
      transform: translate3d(0, 0, 0);
    }

    &.${t}--right-exit.${t}--right-exit-active {
      transform: translate3d(${e}, 0, 0);
      transition: transform 0.2s ease-in-out;
    }

    &.${t}--left-enter {
      transform: translate3d(-${e}, 0, 0);
    }

    &.${t}--left-enter.${t}--left-enter-active {
      transform: translate3d(0, 0, 0);
      transition: transform 0.2s ease-in-out;
    }

    &.${t}--left-exit {
      transform: translate3d(0, 0, 0);
    }

    &.${t}--left-exit.${t}--left-exit-active {
      transform: translate3d(-${e}, 0, 0);
      transition: transform ${s}ms ease-in-out;
    }
  `}
`,j=h.div`
  position: relative;
  width: 100%;
  height: 100%;
  overflow-x: hidden;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
`,$=({animationName:t=D,animationDuration:s=300,backgroundColor:e,backgroundOverlay:o,children:l,from:i="right",isOpen:r,onClickOutside:a,width:p="375px",withPortal:g,transitionProps:v,focusTrapProps:w={}})=>{const m=b(null);N(m,()=>a?.()),O(()=>{const c=x=>{x.key==="Escape"&&r&&a?.()};return r&&window.addEventListener("keydown",c),()=>{window.removeEventListener("keydown",c)}},[a,r]),o&&!a&&console.error("Please provide a clickOutside handler when using backgroundOverlay option in OffCanvas component");const d=`${t}--${i}`,f=k(u,{children:[o&&n(E,{isOpen:r}),n(u,{children:n(y,{in:r,className:`${t} ${d}`,classNames:d,...S,...v,children:n(P,{pause:!r,...w,children:n(T,{ref:m,animationName:t,animationDuration:s,backgroundColor:e,from:i,width:p,role:"dialog","aria-modal":"true","aria-label":"Side panel",children:n(j,{className:`${t}-content`,children:l})})})})})]});return g?C(f,document.body):f};export{$ as OffCanvas,$ as default};
